
<template>
  <div class="company_contracts">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="select">
        <label> {{ translate('tariffication.client_name') }} </label>
        <tree-select
            :options="client_list"
            :multiple="true"
            v-model="filter.client_ids"
            :placeholder="translate('tariffication.client_name')"
            :clearable="true"
            :searchable="true"
        />
      </div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="Object.keys(summary).length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("tariffication.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer w50"
                @click="change_filter('id')"
                :class="{ selected: filter_type === 'id' }"
                scope="col"
            >
              {{ translate('tariffication.id') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer w5per"
                @click="change_filter('active')"
                :class="{ selected: filter_type === 'active' }"
                scope="col"
            >
              {{ translate('tariffication.active') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer text-left"
                @click="change_filter('client_name')"
                :class="{ selected: filter_type === 'client_name' }"
                scope="col"
            >
              {{ translate('tariffication.tariff_client') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer text-left"
                @click="change_filter('name')"
                :class="{ selected: filter_type === 'name' }"
                scope="col"
            >
              {{ translate('tariffication.contract_name') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer text-left"
                @click="change_filter('descr')"
                :class="{ selected: filter_type === 'descr' }"
                scope="col"
                v-if="$store.getters.getPermissions.permissionGod === true"
            >
              {{ translate('tariffication.tariff_descr') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('order_prefix')"
                :class="{ selected: filter_type === 'order_prefix' }"
                scope="col"
            >
              {{ translate('tariffication.order_prefix') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('report_template_filename')"
                :class="{ selected: filter_type === 'report_template_filename' }"
                scope="col"
            >
              {{ translate('tariffication.report_template_filename') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('require_unique_order_id')"
                :class="{ selected: filter_type === 'require_unique_order_id' }"
                scope="col"
            >
              {{ translate('tariffication.require_unique_order_id') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer"
                @click="change_filter('tariffs_count')"
                :class="{ selected: filter_type === 'tariffs_count' }"
                scope="col"
            >
              {{ translate('tariffication.tariffs_count') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer text-right"
                @click="change_filter('devices_count')"
                :class="{ selected: filter_type === 'devices_count' }"
                scope="col"
            >
              {{ translate('tariffication.device_count') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

          </tr>
        </thead>
        <tbody>
            <tr
              v-for="(contract, key) in comp_contract_list"
              :key="key"
              class="tariff_item"
            >
              <td :data-label="translate('tariffication.id')" class="w50">
                {{ contract.id }}
              </td>
              <td :data-label="translate('client_request.type')" class="limit w5per">
                <span class="badge" :style="'background-color: ' + new_active(contract.active).color">
                  {{ new_active(contract.active).title }}
                </span>
              </td>
              <td class="text-left" :data-label="translate('tariffication.client_name')">
                <router-link :to="{path: '/client/' + contract.client_id}">
                  {{ contract.client_name }}
                </router-link>
              </td>
              <td class="text-left" :data-label="translate('tariffication.contract_name')">
                {{ contract.name }}
              </td>
              <td
                  :data-label="translate('tariffication.tariff_descr')"
                  class="descr text-left"
                  v-if="$store.getters.getPermissions.permissionGod === true">
                {{ contract.descr }}
              </td>
              <td :data-label="translate('tariffication.order_prefix')">
                {{ contract.order_prefix }}
              </td>
              <td :data-label="translate('tariffication.report_template_filename')">
                {{ contract.report_template_filename }}
              </td>
              <td :data-label="translate('tariffication.require_unique_order_id')">
                {{ translate(contract.require_unique_order_id ? 'yes' : 'no') }}
              </td>
              <td :data-label="translate('tariffication.tariffs_count')">
                {{ contract.tariffs_count }}
              </td>
              <td class="text-right" :data-label="translate('tariffication.device_count')">
                {{ contract.devices_count }}
              </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>


export default {
  name: "ContractList",
  components: {},
  props: ["tariff_filter"],

  data() {
    return {
      load: true,
      filter: {
        client_ids: [],
      },
      check_link: true,
      contract_list: [],
      summary: {},

      filter_asc: "asc",
      filter_type: "",
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    };
  },
  computed: {
    comp_contract_list(){
      let contract_list = [...this.contract_list];
      return contract_list.sort(this.compareNumbers);
    },
    client_list() {
      return this.$store.getters.getClientsList.map((client) => {
        return {id: client.id, label: client.name}
      })
    },
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (key === 'client_ids'){
          if (this.filter[key].length > 0){
            filter[key] = this.filter[key]
          }
        }else{
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      })
      return filter;
    },
  },

  created() {
    this.check_query()
    this.get_contracts()
  },

  destroyed() {
    this.$modal.hide("tariff_modal");
  },

  watch:{
    sended_filter(){
      this.get_contracts()

      if (this.$route.name === 'tariffication_section' && this.$route.params?.tariffication_section === "contract_list") {
        let string = '?'
        for (let key in this.sended_filter) {
          switch (key) {
            case 'client_ids':
              if (this.filter[key].length > 0){
                string += `&${key}=${this.filter[key]}`
              }
              break;
          }
        }
        history.pushState(null, null, this.$route.path + string)
      }
    }
  },

  methods: {
    new_active(active){
      return (active === 1) ? { title: "Active", color: "green"} : { title: "Not Active", color: "#ccc"}
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return Number(item)
              })
              break;
          }
        }
      }
    },
    get_contracts(){
      this.$http.v1.getContractList(this.sended_filter, (response) => {
        this.contract_list = response.data
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang='scss' scoped>
.company_contracts {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .select {
      width: 20%;
    }

    .checkbox {
      width: 20%;
      margin: 0;
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .response_table{
    flex: 10;
    padding: 0;

    th.text-left, td.text-left{
      text-align: left;
    }

    th.text-right, td.text-right{
      text-align: right;
    }

    .link{
      width: 30px;
    }
  }

  .tariff_item {
    .descr{
      text-wrap: nowrap;
      overflow: hidden;
    }
    .end {
      font-weight: bold;
      color: #eb5e28;
    }
  }

  .summary{
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    margin-bottom: 10px;
    p{
      font-size: 12px;
      line-height: 100%;
      margin-bottom: 0;
    }
    span{
      margin-right: 5px;
      &:last-child{
        margin-right: 0;
      }
      br{
        display: none;
      }
    }
  }

  table {
    height: calc(100% - 55px);
    .active_item {
      background-color: #41b88330;
    }
  }
}

@media (max-width: 768px) {
  .company_contracts {
    .header {
      flex-direction: row;
      flex-wrap: wrap;

      .select {
        width: 100%;
      }

      .checkbox {
        width: 50%;
        margin-bottom: 10px;
        min-width: 100px;
      }

      .button {
        width: 100%;
      }
    }
  }
}
</style>
